import React from "react";
import "./ErrorPage.css";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import Footer from "../../components/footer/Footer";

interface ErrorPageProps {
  errorMessage?: string;
  errorCode?: number;
  errorDescription?: string;
  actionBtn: React.ReactNode;
}

function ErrorPage(props: ErrorPageProps) {
  const navigate = useNavigate();
  return (
    <div className="error-page-container">
      <div className="d-flex flex-column justify-content-center h-100 gap-5 align-items-center">
        <h4>{props.errorMessage}</h4>
        <p>{props.errorDescription}</p>
        <div>{props.actionBtn}</div>
      </div>
      <Footer />
    </div>
  );
}

export default ErrorPage;
